import { clsx, type ClassValue } from 'clsx'

export function cn(...inputs: ClassValue[]) {
  return clsx(inputs)
}

export const formatPrice = (price: string): string => {
  return price.replace(/€(\d+)/, '€$1')
}

export const getServiceIcon = (iconName: string) => {
  const icons: Record<string, string> = {
    users: '👥',
    'shield-check': '🛡️',
    gem: '💎',
    radio: '📡',
    brain: '🧠',
    'document-remove': '📋',
    globe: '🌍'
  }
  return icons[iconName] || '⚡'
}

export const scrollToSection = (sectionId: string) => {
  const element = document.getElementById(sectionId)
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' })
  }
}

export * from './animations'
export * from './accessibility'
export * from './performanceUtils'